// Independent of A-F CCMR — do not import Ccmr/* or write ccmrIndicators*.
const isDemo = process.env.REACT_APP_THEME === 'demo';

const styles = (theme) => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    paddingLeft: 24,
    paddingRight: 24,
    height: '100%',
    position: 'relative',
    fontFamily: isDemo ? 'inherit' : 'Questrial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    margin: 'auto',
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginBottom: 12,
  },
  // Early/Final + funding-FY banner. Color shifts on countsType.
  banner: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 12,
    padding: '10px 16px',
    borderRadius: 4,
    marginBottom: 16,
    fontWeight: 600,
  },
  bannerFinal: {
    background: '#e6f6ec',
    border: '1px solid #68D190',
    color: '#1f7a45',
  },
  bannerEarly: {
    background: '#fff5e6',
    border: '1px solid #D9700F',
    color: '#9a4f08',
  },
  bannerNote: {
    fontWeight: 400,
    fontSize: '0.8rem',
    color: '#888',
  },
  // Hero district total.
  hero: {
    textAlign: 'center',
    padding: '24px 16px',
    borderRadius: 6,
    background: '#f8feff',
    border: '1px solid #b8d8de',
    marginBottom: 16,
  },
  heroLabel: {
    fontSize: '0.9rem',
    letterSpacing: 1,
    textTransform: 'uppercase',
    color: '#4aa3b3',
    marginBottom: 4,
  },
  heroTotal: {
    fontSize: '3rem',
    fontWeight: 700,
    color: '#1f7a45',
    lineHeight: 1.1,
  },
  heroSub: {
    fontSize: '0.85rem',
    color: '#666',
    marginTop: 6,
  },
  // The three cohort cards.
  cohortCards: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 16,
    marginBottom: 12,
  },
  cohortCard: {
    flex: '1 1 240px',
    minWidth: 220,
    border: '1px solid #d9e6e9',
    borderRadius: 6,
    padding: 16,
    background: '#fff',
  },
  cohortTitle: {
    fontWeight: 700,
    textTransform: 'uppercase',
    fontSize: '0.85rem',
    color: '#333',
  },
  cohortRate: {
    fontSize: '0.8rem',
    color: '#888',
    marginBottom: 8,
  },
  cohortRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: '0.85rem',
    padding: '2px 0',
  },
  cohortDollars: {
    fontSize: '1.4rem',
    fontWeight: 700,
    color: '#1f7a45',
    marginTop: 8,
    textAlign: 'right',
  },
  spedNote: {
    fontSize: '0.78rem',
    color: '#888',
    marginBottom: 16,
    fontStyle: 'italic',
  },
  // Bottom split: trend strip stacked on top of the near-qualifier worklist.
  // Stacked (not side-by-side) so the trend row's right-aligned dollar value
  // can never bleed into the worklist column.
  bottomGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    marginTop: 8,
  },
  trendStrip: {
    width: '100%',
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: '0.9rem',
    textTransform: 'uppercase',
    color: '#4aa3b3',
    marginBottom: 8,
  },
  trendRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '4px 0',
    borderBottom: '1px solid #eee',
  },
  trendBarWrap: {
    flex: '1 1 auto',
    height: 10,
    background: '#eef4f5',
    borderRadius: 4,
    margin: '0 12px',
    overflow: 'hidden',
  },
  trendBar: {
    height: '100%',
    background: '#4aa3b3',
  },
  worklist: {
    width: '100%',
  },
  worklistHead: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  worklistRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 8,
    padding: '8px 0',
    borderBottom: '1px solid #eee',
  },
  worklistName: {
    fontWeight: 600,
    minWidth: 160,
  },
  marginalDollars: {
    fontWeight: 700,
    color: '#1f7a45',
    marginLeft: 'auto',
  },
  chip: {
    marginRight: 6,
    marginBottom: 4,
  },
  stackedChip: {
    backgroundColor: '#D9700F',
    color: '#fff',
    '& span': { color: '#fff' },
  },
  missingChip: {
    backgroundColor: '#eef4f5',
  },
  helpText: {
    fontSize: '0.8rem',
    color: '#888',
    marginTop: 8,
  },
  rosterNote: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    fontSize: '0.8rem',
    color: '#888',
    marginBottom: 12,
  },
  // In-page upload dropzone (cloned from AcceleratedTesters).
  uploadZone: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    border: '2px dashed #b8d8de',
    borderRadius: 6,
    background: '#f8feff',
    padding: 20,
    marginBottom: 16,
    cursor: 'pointer',
    transition: 'background 0.15s ease, border-color 0.15s ease',
  },
  uploadZoneActive: {
    background: '#eef9fb',
    borderColor: '#4aa3b3',
  },
  uploadZoneBusy: {
    cursor: 'default',
    opacity: 0.7,
  },
  uploadTitle: {
    fontWeight: 600,
    marginBottom: 4,
  },
  uploadHint: {
    fontSize: '0.8rem',
    color: '#888',
  },
  uploadIcon: {
    fontSize: 28,
    color: '#4aa3b3',
    marginBottom: 4,
  },
  exportRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: 8,
  },
  success: {
    backgroundColor: '#68D190',
  },
  error: {
    backgroundColor: '#FF5656',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fontSize: 20,
    marginRight: 8,
  },
});

export default styles;
